/* Custom product video carousel: initialize near the viewport. */
(() => {
  if (window.flycatcherVideoCarouselsInstalled) return;
  window.flycatcherVideoCarouselsInstalled = true;

  const selector = '[data-flycatcher-video-carousel]';
  const states = new Map();

  function setArrow(button, path) {
    if (!button) return;
    button.innerHTML = '<svg aria-hidden="true" width="25" height="25" viewBox="0 0 25 25" fill="none">' +
      '<path d="' + path + '" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function setup(track) {
    if (states.has(track)) return;
    const cells = track.querySelectorAll('.carousel-cell');
    if (!cells.length) return;

    const state = { observer: null, instance: null, visible: false };
    states.set(track, state);

    function start() {
      if (state.instance || !track.isConnected || typeof window.Flickity !== 'function') return;
      state.instance = new window.Flickity(track, {
        initialIndex: Math.floor(cells.length / 2),
        contain: true,
        freeScroll: true,
        wrapAround: true
      });
      if (state.observer) state.observer.disconnect();
      setArrow(track.querySelector('.flickity-previous'), 'M11 20L3.5 12.5M3.5 12.5L11 5M3.5 12.5H21.5');
      setArrow(track.querySelector('.flickity-next'), 'M14 20L21.5 12.5M21.5 12.5L14 5M21.5 12.5H3.5');
    }
    state.start = start;

    function play(event) {
      const thumbnail = event.target.closest('.video-thumbnail[data-video-id]');
      if (!thumbnail || !track.contains(thumbnail) || thumbnail.querySelector('iframe')) return;
      const videoId = thumbnail.dataset.videoId.trim();
      if (!videoId) return;
      event.preventDefault();
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
      iframe.title = 'Product video';
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.style.border = 'none';
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      thumbnail.replaceChildren(iframe);
    }
    track.addEventListener('click', play);
    track.addEventListener('focusin', start);
    state.cleanup = () => {
      if (state.observer) state.observer.disconnect();
      if (state.instance) state.instance.destroy();
      track.removeEventListener('click', play);
      track.removeEventListener('focusin', start);
    };

    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
      state.visible = true;
      start();
    } else {
      state.observer = new IntersectionObserver((entries) => {
        state.visible = entries.some((entry) => entry.isIntersecting);
        if (state.visible) start();
      }, { rootMargin: '400px 0px' });
      state.observer.observe(track);
    }
  }

  function scan(scope) {
    if (scope.matches && scope.matches(selector)) setup(scope);
    scope.querySelectorAll(selector).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  window.addEventListener('load', () => {
    states.forEach((state) => { if (state.visible) state.start(); });
  }, { once: true });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    states.forEach((state, track) => {
      if (event.target.contains(track)) {
        state.cleanup();
        states.delete(track);
      }
    });
  });
})();